<template>

</template>

<script type="text/jsx">
    import CampaignConfigurationMixin from '../../../../../assets/js/components/frontend/mixin/campaign-configuration.vue'
    export default {
        name: 'order-creation',
        mixins: [
            CampaignConfigurationMixin,
        ],
        computed: {
            salesTax: function () {
                var result = 0.0;
                result += this.taxableAmount * this.taxRate;
                return result;
            },
            orderTotal: function () {
                var result = 0.0;
                result += this.subTotal;
                result += this.taxableAmount * this.taxRate;
                if (this.isConvenienceFeeAllowed) {
                    result += this.convenienceFee;
                }
                return result;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// order-creation.vue?2aeb080f